import axiosInstance from "../../api/axiosConfig";
import logger from "../../utils/logger";

const API_URL = "/calendar";
const API_URL_PUBLIC = "/calendarP";
const PUBLIC_API_SECRET = process.env.REACT_APP_TOKEN_PETICIONES;

function getAuthHeaders() {
  const token = localStorage.getItem('turnlinkToken');
  return token ? { Authorization: `Bearer ${token}` } : {};
}

const CalendarService = {

  //actualizados con autenticación  
  getAppointments: async (clientId, staffId) => {
    try{
      return await axiosInstance.get(`${API_URL}/appointments`, {
        params: { clientId, staffId },
        headers: getAuthHeaders()
      });
    } catch (error) {
      const message = error.response && error.response.data && error.response.data.message
        ? error.response.data.message
        : error.message || "Error fetching appointments";
      throw new Error(message);
    }
  },

  createAppointmentAdmin: (appointmentData) => {
    const { clientId, staffId, ...data } = appointmentData;
    return axiosInstance.post(`${API_URL}/create-appointment`, data, {
      params: { clientId, staffId },
      headers: getAuthHeaders()
    });
  },

  cancelAppointment: (appointmentId, clientId, staffId) => {
    return axiosInstance.delete(`/calendar/appointments/${appointmentId}`, {
      params: { clientId, staffId },
      headers: getAuthHeaders()
    });
  },

  disconnectGoogleCalendar: async (clientId, staffId) => {
    try {
      const response = await axiosInstance.post(`${API_URL}/disconnect/${clientId}/${staffId}`, {}, {
        headers: getAuthHeaders()
      });
      return response.data;
    } catch (error) {
      logger.error("Error disconnecting Google Calendar:", error);
      throw error;
    }
  },

  disconnectWhatsApp: async (clientId) => {
    try {
      const response = await axiosInstance.post(`${API_URL}/whatsapp/disconnect/${clientId}`, {}, {
        headers: getAuthHeaders()
      });
      return response.data;
    } catch (error) {
      logger.error("Error disconnecting WhatsApp:", error);
      throw error;
    }
  },


  // fin de actualizados con autenticación

  getAvailableDays: (clientId, staffId, includeFull = false) => {
    return axiosInstance.get(`${API_URL_PUBLIC}/available-days`, {
      params: { clientId, staffId, token: PUBLIC_API_SECRET, ...(includeFull && { includeFull: true }) }
    });
  },

  getAvailableSlots: (clientId, date, serviceDuration, staffId) => {
    return axiosInstance.get(`${API_URL_PUBLIC}/available-slots`, {
      params: { clientId, date, serviceDuration, staffId, token: PUBLIC_API_SECRET }
    });
  },

  createAppointment: (data) => {
    return axiosInstance.post(`${API_URL_PUBLIC}/create-appointment`, { ...data, token: PUBLIC_API_SECRET });
  },

  // Confirmar pago pendiente desde el dashboard (admin)
  confirmPendingPayment: (blockEventId, staffId, telefono, clientId) => {
    return axiosInstance.post(`/calendar/appointments/confirm-payment`, 
      { blockEventId, staffId, telefono, clientId },
      { headers: getAuthHeaders() }
    );
  },

  // Obtener ingresos por rango de fechas
  getIncomeRange: (clientId, staffId, startDate, endDate) => {
    return axiosInstance.get(`${API_URL}/income-range`, {
      params: { clientId, staffId, startDate, endDate },
      headers: getAuthHeaders()
    });
  },

};

export default CalendarService;
